import { Injectable, inject } from '@angular/core';
import { SupabaseService } from '../supabase/supabase.service';
import { BehaviorSubject } from 'rxjs';

export interface Tenant {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class TenantsService {
  private supabase = inject(SupabaseService);

  private tenants: Tenant[] = [];
  private _activeTenant = new BehaviorSubject('');

  /**
   * Returns the tenantId of the given tenant. If no tenant is given it uses the current active one
   * @param tenant
   */
  id(tenant: string = this.activeTenant): string | undefined {
    return this.tenants.find((t) => t.name === tenant)?.id || undefined;
  }

  /**
   * Returns the friendly name of the current active tenant
   */
  get activeTenant(): string {
    return this._activeTenant.value;
  }

  set activeTenant(value: string) {
    this._activeTenant.next(value);
  }

  get activeTenant$(): BehaviorSubject<string> {
    return this._activeTenant;
  }

  async getTenants(): Promise<Tenant[]> {
    if (this.tenants.length === 0) {
      this.tenants = (
        await this.supabase.client.from('tenants').select('id,name')
      ).data as Tenant[];
    }
    return this.tenants;
  }
}
